import { z } from 'zod';

import { TopRightType } from '../../enums';

export const textTopRightSchema = z.object({
  type: z.literal(TopRightType.TEXT),
  title: z.string(),
});

export type TextTopRightType = z.infer<typeof textTopRightSchema>;
